<template>
  <div>
    <ul v-if="isRootDB">
      <li
        v-for="(db, index) in data"
        :key="db.id"
        class="v-hiveColumn"
        @click.stop="dispatch($event, 'we-click', db, index)"
        @contextmenu.prevent.stop="
          dispatch($event, 'we-contextmenu', db, index)
        "
        @mousedown.prevent
      >
        <span :class="getDBCls(db)" />
        <div class="inline-box">
          <Tooltip placement="right" transfer :max-width="300">
            <div slot="content">{{ db.remark || '暂无描述' }}</div>
            <span class="v-ellipsis">{{ db.name }}</span>
          </Tooltip>
          <ul
            v-for="(table, tableIndex) in db.children"
            v-if="db.isOpen && table.isVisible"
            :key="table.id"
            class="v-hiveColumn"
            :class="{ canAccess: table.isAcl, noright: !table.isAcl }"
            @click.stop="dispatch($event, 'we-click', table, tableIndex)"
            @contextmenu.prevent.stop="dispatch($event, 'we-contextmenu', table, tableIndex)"
            @mousedown.prevent
            @dblclick.prevent.stop="
              dispatch($event, 'we-dblclick', table, tableIndex)"
          >
            <span :class="getDBCls(table)" />
            <div class="inline-box">
              <Tooltip placement="right" transfer :max-width="300">
                <div slot="content">{{ table.remark || '暂无描述' }}</div>
                <span class="v-ellipsis">{{ table.name }}</span>
              </Tooltip>
              <template v-if="table.isOpen">
                <li
                  v-for="(field, fieldIndex) in table.children"
                  :key="fieldIndex"
                  class="v-hiveColumn"
                  :class="{ canAccess: field.isAcl, noright: !field.isAcl }"
                  @click.stop="dispatch($event, 'we-click', field, fieldIndex)"
                  @contextmenu.prevent.stop="
                    dispatch($event, 'we-contextmenu', field, fieldIndex)"
                  @mousedown.prevent
                  @dblclick.prevent.stop="
                    dispatch($event, 'we-dblclick', field, fieldIndex)"
                >
                  <div v-if="fieldIndex == 100">
                    <span class="v-hivetable-text">{{
                      $t("message.hiveTableDesc.viewTableColumns")
                    }}</span>
                  </div>
                  <div v-else-if="fieldIndex > 100" />
                  <div v-else>
                    <Tooltip placement="right" transfer :max-width="300">
                      <div slot="content">{{ field.columnComment }}</div>
                      <span :class="getDBCls(field)" />
                      <span  class="v-hivetable-type"
                        >[{{ field.type }}]</span
                      >
                      <span  class="v-hivetable-text">{{
                        field.name
                      }}</span>
                    </Tooltip>
                  </div>
                </li>
              </template>
            </div>
          </ul>
        </div>
      </li>
    </ul>
    <ul
      v-else
      v-for="(table, tableIndex) in data"
      :key="table.id"
      class="v-hiveColumn"
      :class="{ canAccess: table.isAcl, noright: !table.isAcl }"
      @click.stop="dispatch($event, 'we-click', table, tableIndex)"
      @contextmenu.prevent.stop="
        dispatch($event, 'we-contextmenu', table, tableIndex)
      "
      @mousedown.prevent
      @dblclick.prevent.stop="
        dispatch($event, 'we-dblclick', table, tableIndex)
      "
    >
      <span :class="getDBCls(table)" />
      <div class="inline-box">
        <Tooltip placement="right" transfer :max-width="300">
          <div slot="content">{{ table.remark || '暂无描述' }}</div>
          <span class="v-ellipsis">{{ table.name }}</span>
        </Tooltip>
        <li
          v-for="(field, fieldIndex) in table.children"
          v-if="table.isOpen"
          :key="fieldIndex"
          class="v-hiveColumn"
          :class="{ canAccess: field.isAcl, noright: !field.isAcl }"
          @click.stop="dispatch($event, 'we-click', field, fieldIndex)"
          @contextmenu.prevent.stop="
            dispatch($event, 'we-contextmenu', field, fieldIndex)"
          @mousedown.prevent
          @dblclick.prevent.stop="
            dispatch($event, 'we-dblclick', field, fieldIndex)"
        >
          <div
            v-if="fieldIndex == 100"
          >
            <span class="v-hivetable-text">{{
              $t("message.hiveTableDesc.viewTableColumns")
            }}</span>
          </div>
          <div v-else-if="fieldIndex > 100" />
          <div v-else>
            <Tooltip placement="right" transfer :max-width="300">
              <div slot="content">{{ field.columnComment }}</div>
              <span :class="getDBCls(field)" />
              <span  class="v-hivetable-type"
                >[{{ field.type }}]</span
              >
              <span class="v-hivetable-text">{{
                field.name
              }}</span>
            </Tooltip>
          </div>
        </li>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  name: "WeHiveList",
  props: {
    data: Array,
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      root: null,
      isRootDB: false,
    };
  },

  created() {
    const parent = this.$parent;
    this.root = parent.isRoot ? parent : parent.root;
  },
  watch:{
    data(value){
      this.isRootDB = this.data[0].dataType == "db";
    }
  },
  methods: {
    dispatch(ev, name, item, index) {
      this.root.$emit(name, {
        ev,
        item,
        index,
      });
    },
    getTitle(item) {
      return this.title ? item[this.title] : "";
    },
    getDBCls(item) {
      let cls = item.isOpen ? item.iconCls + " open" : item.iconCls;
      return cls;
    },
  },
};
</script>
<style lang="sass" src="./index.sass"></style>
<style lang="css">
.canAccess {
  color: rgb(13, 156, 13);
}
.noright {
  color: gray;
}
</style>